import axios from '../config.js';
const resource = '/medicine';

export default {
  get(id='', per_page='', page='', search='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    if (per_page)  params.append('per_page', per_page);
    if (page)     params.append('page', page);
    if (search)     params.append('search', search);
    return axios.get(`${resource}${id ? `/${id}`: ''}`, { params: params });
  },
  search(search='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.get(`${resource}${search ? `?search=${search}`: ''}`);
  },

  /**
   * Fetch medical codes
   * @param {Number} per_page - maximum number of data/limit
   * @param {Number} page - page in the database
   */
  getCodes(per_page='', page='', search='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    const params = new URLSearchParams();
    if (per_page)  params.append('per_page', per_page);
    if (page)     params.append('page', page);
    if (search)     params.append('search', search);
    return axios.get(`${resource}/code`, { params: params });
  },
  /**
   * Search medical codes
   * @param {String} search - term/word to to search for in the list 
   */
  searchCode(search='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.get(`${resource}/code${search ? `?search=${search}`: ''}`);
  },

  updateFavorites (data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.post(`${resource}/fav`, data);
  },

  getFavorites () {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.get(`${resource}/fav`);
  },

  updateMostUsed (data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.post(`${resource}/most/used`, data)
  }
};